import { INTELLIGENT_PHOTO_CAPTURE_IMAGE_CONTENT_DETECTION_FAILURE, INTELLIGENT_PHOTO_CAPTURE_IMAGE_CONTENT_DETECTION_REQUEST, INTELLIGENT_PHOTO_CAPTURE_IMAGE_CONTENT_DETECTION_SUCCESS } from '../actions';
import { IntelligentPhotoCaptureImageDetectionConstants } from '../constants';
export const photoCaptureIntelligentImageContentDetectionReducer = (state, action) => {
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_IMAGE_CONTENT_DETECTION_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true });
        case INTELLIGENT_PHOTO_CAPTURE_IMAGE_CONTENT_DETECTION_SUCCESS:
            return Object.assign(Object.assign({}, state), { isLoading: false, imageContentDetection: {
                    results: action.payload.imageContentDetectionResponse.results
                } });
        case INTELLIGENT_PHOTO_CAPTURE_IMAGE_CONTENT_DETECTION_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, imageContentDetection: {
                    results: [],
                    error: IntelligentPhotoCaptureImageDetectionConstants.CONTENT_DETECTION_FAILED_MESSAGE
                } });
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentImageContentDetectionReducer.js.map